import * as C from './consts';
import { boundApiReducer as api, boundReducer } from 'redux-upgrader';

export const tosInfo = api(C.GET_TOS_INFO, Array);
